import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { buildQueryString } from '../../shared/utils/StringUtils';

import { RuntimeContext } from '../../../common/RuntimeContext';
import { getCompanyByPermalink } from '../../shared/actions/index';
import LoadingIndicator from '../../shared/components/LoadingIndicator';

class NotificationCallback extends Component {
    static propTypes = {
        getCompanyByPermalink: PropTypes.func,
        location: PropTypes.object.isRequired,
        isAuthenticated: PropTypes.bool,
        history: PropTypes.shape({
            push: PropTypes.func
        })
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            redirectLink: null,
            nextPath: null
        };
    }

    _parseQueryString = (queryString) => {
        const queryStringParamsArray = queryString.replace(/^\?/, '').split('&');
        const queryStringParamsObject = {};
        let key;
        let value;
        queryStringParamsArray.forEach((string) => {
            [key, value] = string.split('=');
            queryStringParamsObject[key] = value;
        });

        if (queryStringParamsObject.redirectParams) {
            const redirectParams = JSON.parse(decodeURIComponent(queryStringParamsObject.redirectParams));
            queryStringParamsObject.redirect = buildQueryString(redirectParams, queryStringParamsObject.redirect);
            delete queryStringParamsObject.redirectParams;
        }

        return queryStringParamsObject;
    };

    componentDidMount() {
        const {
            isAuthenticated,
            location: { search = '' } = {},
            getCompanyByPermalink,
        } = this.props;
        const { permalink: companyPermalink, redirect: nextPath } = this._parseQueryString(search);

        if (isAuthenticated) {
            return this.props.history.push(nextPath);
        }

        return getCompanyByPermalink({ permalink: companyPermalink, pathsContext: this.context.pathsWeb });
    }

    // eslint-disable-next-line class-methods-use-this
    render() {
        return (
            <div className={'notification-callback'}>
                <LoadingIndicator />
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    const {
        auth: { isAuthenticated }
    } = state;
    return {
        isAuthenticated
    };
};

export const mapDispatchToProps = (dispatch) => ({
    getCompanyByPermalink: (params) => dispatch(getCompanyByPermalink(params)),
});

export const NotificationCallbackComponent = NotificationCallback;

export default connect(mapStateToProps, mapDispatchToProps)(NotificationCallback);
